import { useEffect } from "react";
import { holdBackdrop } from "../lib/backdrop-idle";

/**
 * Suspend le fond animé tant que `active` est vrai. À utiliser dès qu'un
 * panneau recouvre l'écran ou qu'une carte vole : le fond n'est alors plus
 * regardé, et le rendre continue coûterait au moment le plus chargé.
 */
export const useBackdropHold = (active: boolean): void => {
  useEffect(() => {
    if (!active) return;
    return holdBackdrop();
  }, [active]);
};
